import React from 'react';
import { Link } from 'react-router-dom';

const LEGAL_FOOTER_LINKS = [
  { to: '/terms-of-use', label: 'Terms of Use' },
  { to: '/privacy-policy', label: 'Privacy Policy' },
  { to: '/refund-policy', label: 'Refund Policy' },
  { to: '/contact', label: 'Contact' },
];

function Footer() {
  return (
    <footer className="bg-gradient-to-r from-blue-600 to-blue-400">
      <div className="container mx-auto px-4 py-10">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-8 md:gap-10 mb-8">
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">McKinsey Prep</h4>
            <ul className="space-y-2 leading-relaxed">
              <li><Link to="/mckinsey-ai-coach" className="text-blue-100 hover:text-white text-sm transition-colors">AI Coach</Link></li>
              <li><Link to="/seawolf" className="text-blue-100 hover:text-white text-sm transition-colors">Sea Wolf Simulation</Link></li>
              <li><Link to="/seawolf-practice" className="text-blue-100 hover:text-white text-sm transition-colors">Sea Wolf Practice</Link></li>
              <li><Link to="/redrock" className="text-blue-100 hover:text-white text-sm transition-colors">Red Rock</Link></li>
              <li><Link to="/redrock-guide" className="text-blue-100 hover:text-white text-sm transition-colors">Free Practice</Link></li>
              <li><Link to="/ecosystem-solver" className="text-blue-100 hover:text-white text-sm transition-colors">Ecosystem Solver</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">BCG Prep</h4>
            <ul className="space-y-2 leading-relaxed">
              <li><Link to="/bcg-ai-coach" className="text-blue-100 hover:text-white text-sm transition-colors">AI Coach</Link></li>
              <li><Link to="/bcg-casey-simulation" className="text-blue-100 hover:text-white text-sm transition-colors">Casey Simulation</Link></li>
              <li><Link to="/bcg-casey-guide" className="text-blue-100 hover:text-white text-sm transition-colors">Casey Guide</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Resources</h4>
            <ul className="space-y-2 leading-relaxed">
              <li><Link to="/about" className="text-blue-100 hover:text-white text-sm transition-colors">About Cognidoor</Link></li>
              <li><Link to="/consulting-math-guides" className="text-blue-100 hover:text-white text-sm transition-colors">Consulting Math</Link></li>
              <li><Link to="/about-solve" className="text-blue-100 hover:text-white text-sm transition-colors">About Solve</Link></li>
              <li><Link to="/about-bcg-casey" className="text-blue-100 hover:text-white text-sm transition-colors">About BCG Casey</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Legal</h4>
            <ul className="space-y-2 leading-relaxed">
              {LEGAL_FOOTER_LINKS.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-blue-100 hover:text-white text-sm transition-colors">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h4 className="text-white font-semibold text-sm mb-4">Get Started</h4>
            <ul className="space-y-2 leading-relaxed">
              <li><Link to="/auth" className="text-blue-100 hover:text-white text-sm transition-colors">Try Free</Link></li>
              <li><Link to="/#pricing" className="text-blue-100 hover:text-white text-sm transition-colors">Pricing</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-blue-300/30 pt-6">
          <nav
            className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-blue-100 mb-4 lg:hidden"
            aria-label="Legal links"
          >
            {LEGAL_FOOTER_LINKS.map((link) => (
              <Link key={link.to} to={link.to} className="hover:text-white transition-colors">
                {link.label}
              </Link>
            ))}
          </nav>
          <p className="text-white text-sm text-center leading-relaxed">
            &copy; 2026 Cognidoor. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
